import Form from "@rjsf/react-bootstrap";
import React, { FunctionComponent, useEffect, useState } from "react";
import { JSONSchema7 } from "json-schema";
import { Link, useNavigate } from "react-router";
import { toast } from "react-toastify";
import firebase from "firebase/compat/app";
import { Spinner } from "react-bootstrap";
import { UiSchema } from "@rjsf/utils";
import validator from "@rjsf/validator-ajv8";
import { Helmet } from "react-helmet";

import { getErrorByCode } from "../../helper/firebase/getErrorByCode";
import { useAuthResetPassword } from "../../hooks/useAuthResetPassword";
import { AuthLayout } from "./AuthLayout";

const schema: JSONSchema7 = {
  type: "object",
  required: ["email"],
  properties: {
    email: {
      type: "string",
      title: "E-Mail"
    }
  }
};

const uiSchema: UiSchema = {
  email: {
    "ui:widget": "email"
  }
};

interface Props {
  user: firebase.User | null | undefined;
}

const ResetPassword: FunctionComponent<Props> = ({ user }: Props) => {
  const navigate = useNavigate();
  const { resetPassword, isLoading } = useAuthResetPassword();
  const [resetSubmitted, setResetSubmitted] = useState<boolean>(false);

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user, navigate]);

  const submitResetPassword = async (formData: any): Promise<void> => {
    const { email } = formData;

    resetPassword(email)
      .then(() => setResetSubmitted(true))
      .catch((e) => {
        toast.error(`Zurücksetzen des Passworts ist fehlgeschlagen. ${getErrorByCode(e.code)}`);
      });
  };

  return (
    <>
      <Helmet>
        <title>Spielgruppe Online - Passwort zurücksetzen</title>
        <meta
          name="description"
          content="Setzen Sie Ihr Passwort zurück, um wieder Zugang zu Ihrem Konto zu erhalten"
        />
      </Helmet>
      <AuthLayout
        title={"Passwort zurücksetzen"}
        lead={"Geben Sie Ihre E-Mail ein, um Ihr Passwort zurückzusetzen"}
        footer={
          <p>
            Passwort wieder eingefallen? <Link to="/">Zur Anmeldung</Link>
          </p>
        }>
        <Form
          validator={validator}
          schema={schema}
          uiSchema={uiSchema}
          onSubmit={(e) => submitResetPassword(e.formData)}
          showErrorList={false}
          className="reset-form">
          <p className="auth-card__hint">
            Sie erhalten eine E-Mail mit den Anweisungen zum Zurücksetzen des Passworts.
          </p>
          <button disabled={isLoading || resetSubmitted} type="submit" className="btn btn-primary btn-lg">
            Passwort zurücksetzen {isLoading && <Spinner size={"sm"} animation={"border"} />}
          </button>
        </Form>

        {resetSubmitted && (
          <div className="alert alert-primary mt-3">
            Bitte prüfen Sie Ihr E-Mail Postfach und folgen Sie den Anweisungen des erhaltenen E-Mails.
          </div>
        )}
      </AuthLayout>
    </>
  );
};

export default ResetPassword;
